import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=0bc57ea1&scoped=true&"
import script from "./Show.vue?vue&type=script&lang=js&"
export * from "./Show.vue?vue&type=script&lang=js&"
import style0 from "../../components/common/css/Eit.css?vue&type=style&index=0&id=0bc57ea1&scoped=true&lang=css&"
import style1 from "../../components/common/css/Accreditation.css?vue&type=style&index=1&id=0bc57ea1&scoped=true&lang=css&"
import style2 from "./Show.vue?vue&type=style&index=2&id=0bc57ea1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc57ea1",
  null
  
)

export default component.exports